import { getTimezoneOffset, isShippedZone } from "./timezone-data";
import type { TimezoneBridge } from "./types";

// @internationalized/date reads this at call time; see patches/@internationalized__date@3.12.0.patch.
const bridgeHost = globalThis as typeof globalThis & { __offstreetTimezone?: TimezoneBridge };

export const installTzdataConversions = () => {
	if (bridgeHost.__offstreetTimezone) {
		return;
	}

	bridgeHost.__offstreetTimezone = {
		hasZone: isShippedZone,
		offsetMinutes: (instant, zoneName) => getTimezoneOffset({ instant, zoneName }),
	};
};
